


















































import Enumerable from "linq";
import Moment from "moment";
import { Component, Mixins } from "vue-property-decorator";
import { RecordFilter } from "./model";
import { DocumentDurationOptionsSource } from "../../../selectors/options";
import { DateDurationPicker, ModelEditableMixin } from "../../../../system";
import { DateDuration } from "../../../../../domain/system";

@Component({
  components: {
    DateDurationPicker,
  }
})
export default class AiPhraseRecordFilter extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: RecordFilter) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: RecordFilter) => T, defaultValue: T) => T;

  data(): any {
    return {
      activeNames: [],
      containsAll: false,
      containsBasis: false,
      excludesBasis: false,
    };
  }
  activeNames: string[];
  containsAll: boolean;
  containsBasis: boolean;
  excludesBasis: boolean;

  get duration(): DateDuration {
    return new DateDuration(this.readPropertyOrDefault(s => s.createdAtFrom, null), this.readPropertyOrDefault(s => s.createdAtTo, null));
  }

  set duration(value: DateDuration) {
    this.writePropertyWhenValid(s => s.createdAtFrom = value.from);
    this.writePropertyWhenValid(s => s.createdAtTo = value.to);
  }

  get isImportant(): boolean {
    return this.readPropertyOrDefault(s => s.isImportant, undefined);
  }

  set isImportant(value: boolean) {
    this.writePropertyWhenValid(s => s.isImportant = value);
  }

  get authorName(): string | null {
    return this.readPropertyOrDefault(s => s.author, "");
  }

  set authorName(value: string) {
    this.writePropertyWhenValid(s => s.author = value);
  }

  get departmentName(): string | null {
    return this.readPropertyOrDefault(s => s.department, "");
  }

  set departmentName(value: string) {
    this.writePropertyWhenValid(s => s.department = value);
  }

  get recordText(): string {
    return this.readPropertyOrDefault(s => s.value, "");
  }

  set recordText(value: string) {
    this.writePropertyWhenValid(s => s.value = value);
  }

  get conditionsString(): string {
    const text = Enumerable.from([
      this.durationConditionString,
      this.isImportantConditionString,
      this.authorConditionString,
      this.departmentConditionString,
      this.valueConditionString,
    ])
    .where(t => !!t)
    .toArray()
    .join("");
    return "絞り込み：" + (text ? text : "なし");
  }

  get durationConditionString(): string {
    return (!this.duration || (!this.duration.from && !this.duration.to))
      ? ""
      : this.formatConditionString("記載日", this.toDurationString(this.duration));
  }

  get isImportantConditionString(): string {
    if (this.isImportant === true) {
      return this.formatConditionString("生成根拠", "判断済");
    } else if (this.isImportant === false) {
      return this.formatConditionString("生成根拠", "未判断");
    } else {
      return "";
    }
  }

  get authorConditionString(): string {
    return !!this.authorName ? this.formatConditionString("記載者", this.authorName) : "";
  }

  get departmentConditionString(): string {
    return !!this.departmentName ? this.formatConditionString("診療科", this.departmentName) : "";
  }

  get valueConditionString(): string {
    return !!this.recordText ? this.formatConditionString("内容", this.recordText) : "";
  }

  private formatConditionString(name: string, value: string): string {
    return value
      ? (name + "【" + value + "】")
      : "";
  }

  private toDurationString(source: DateDuration): string {
    if ((source.from && source.to) || (!source.from && !source.to)) {
      const durationString = DocumentDurationOptionsSource.toDurationString(source);
      return durationString
        ? durationString
        : Moment(source.from).format("YY/MM/DD") + " ～ " + Moment(source.to).format("YY/MM/DD");
    } else if (source.from) {
      return Moment(source.from).format("YY/MM/DD") + " ～";
    } else {
      return  "～ " + Moment(source.to).format("YY/MM/DD");
    }
  }

  clear(): void {
    this.writePropertyWhenValid(s => {
      s.createdAtFrom = null;
      s.createdAtTo = null;
      s.isImportant = undefined;
      s.author = "";
      s.department = "";
      s.value = "";
    });
  }
}
